import { storeStructure } from '../store/reducers';
import formGroupVoDGeneralSettings from './formGroupVoDGeneralSettings';
import formGroupEditVod from './formGroupEditVod';
import formGroupEditVodOutputs from './formGroupEditVodOutputs';
import formGroupEditVodOrigins from './formGroupEditVodOrigins';
import formGroupEditVodEncodingSettings from './formGroupEditVodEncodingSettings';
import formGroupEditVodOptimizationSettings from './formGroupEditVodOptimizationSettings';
import formGroupEditVodLogs from './formGroupEditVodLogs';
import formGroupProxyConfig from './formGroupProxyConfig';
import formGroupOutput from './formGroupOutput';
import routes from '../routes/route';

export default {
  title: 'VoD Edit',
  attributeName: storeStructure.VoD,
  createURL: 'vod',
  sessionParams: [],
  getURL: 'vod',
  updateURL: 'vod',
  idAttribute: 'id',
  saveIdSessionNameAs: 'vodId',
  noArea: true,
  goBack: true,
  autoUpdate: false,
  idUpdate:true,
  redirectUrl: routes.VOD.path,
  websocketChannel: 'vodDetails-vodId',
  websocketSessionParams: ['vodId'],
  websocketItem: 'vodDetails',
  formConfig: [
    formGroupVoDGeneralSettings,
    formGroupOutput,
    formGroupEditVod,
    formGroupEditVodOutputs,
    formGroupEditVodOrigins,
    formGroupEditVodEncodingSettings,
    formGroupEditVodOptimizationSettings,
    formGroupEditVodLogs,
  ],
};
